import { Component, Input, OnInit } from "@angular/core";
import * as moment from "moment";
import { ConvertDatetimePipe } from "../../../app/convert-datetime.pipe";
import { PowerTrainService } from "../../../app/services/powertrain.service";
import * as CanvasJS from "./canvasjs.stock.min";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-powertrain-healthbar",
  templateUrl: "./powertrain-healthbar.component.html",
  styleUrls: ["./powertrain-healthbar.component.scss"],
  standalone:true,
  imports:[CommonModule]
})
export class PowertrainHealthbarComponent implements OnInit {
  powertrainHealthBarUrl = BaseUrlConstantsService.POWERTRAIN_HEALTH_BAR_API;

  @Input("asset_ids") asset_ids: string[] = [];
  @Input("mac_addresses") mac_addresses: string[] = [];
  @Input("client_id") client_id: string[] = [];

  public stackvelocitychartLoader = false;
  public stackvelocitychartErr = "";

  constructor(private service: PowerTrainService) {}

  ngOnInit(): void {
    this.fetchMachineHealthbar();
  }

  fetchMachineHealthbar() {
    this.stackvelocitychartLoader = true;
    this.service
      .fetchPowertrainHealthBar(
        `${
          // "http://localhost:7777/powertrain/machineHealthStatus"
          this.powertrainHealthBarUrl
        }?clientId=${this.client_id}&assetIds=${this.asset_ids.join(
          ","
        )}&macAddresses=${this.mac_addresses.join(",")}`
      )
      .then((result: any) => {
        console.log(result.length)
        if (!result.length) {
          console.log("GOING IN IF")
          this.stackvelocitychartErr = "No Data Available";
        } else {
          this.stackvelocitychartErr = "";
          let stackData = [];
          for (let i = 1; i < result.length; i++) {
            let testDateUtc = moment.utc(result[i].bucket_date).toDate();
            let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(
              testDateUtc
            );

            let dateandtime = timeUpdatedAt.split(" ");
            let date = dateandtime[0].toString();
            let time = dateandtime[1].toString();
            stackData.push({
              type: "stackedBar",
              indexLabelFontColor: "red",
              xValueFormatString: time,

              color: result[i].highest_val == 0 ? "gray" : result[i].color,
              dataPoints: [{ x: 0, y: 30 }],
            });
          }
          const chart11 = new CanvasJS.Chart("stackvelocitychartContainer", {
            axisX: {
              valueFormatString: " ",
              titleFontSize: 100,
              gridThickness: 0,
              lineThickness: 0,
              tickThickness: 0,
            },
            axisY: {
              titleFontSize: 135,
              valueFormatString: " ",
              gridThickness: 0,
              lineThickness: 0,
              tickThickness: 0,
            },
            toolTip: {
              content: "{x}",
              shared: false,
            },
            dataPointWidth: 65,

            data: stackData,
            afterRender: function () {
              this.stackvelocitychartLoader = false;
            },
          });
          chart11.render();
        }
      })
      .catch((err) => {
        console.log(err);
        this.stackvelocitychartErr = "No Data Available";
      })
      .finally(() => {
        this.stackvelocitychartLoader = false;
      });
  }
}
